import React from 'react';
import './index.scss';

export default class TabList extends React.Component {

  onTabItem = (key) => {
    const { onHandleTab } = this.props;
    onHandleTab && onHandleTab(key);
  }

  render() {
    const { active } = this.props;
    return (
      <ul className="tab-list">
        <li className={`tab-list-item ${active === 'sgx' ? 'active' : ''}`} onClick={() => this.onTabItem('sgx')}>
          <img className="logo-icon" src={require('./../../../../assets/images/header/sgx_logo.png')} alt="" />
          <span className="tab-list-title">时光序</span>
        </li>
        <li className={`tab-list-item ${active === 'wlgj' ? 'active' : ''}`} onClick={() => this.onTabItem('wlgj')}>
          <img className="logo-icon" src={require('./../../../../assets/images/header/logo.png')} alt="" />
          <span className="tab-list-title">未来管家</span>
        </li>
        {/* <li className={`tab-list-item ${active === 'timeplan' ? 'active' : ''}`} onClick={() => this.onTabItem('timeplan')}>
          <img className="logo-icon" src={require('./../../../../assets/images/header/timeplan_logo.png')} alt="" />
          <span className="tab-list-title">TimePlan</span>
        </li> */}
      </ul>
    );
  }
}